/**
 * Trim text to maximum 30 characters (mirrors backend validation)
 */
export const trimTo30 = (text) => {
  if (!text) return '';
  
  const trimmed = text.trim();
  if (!trimmed) return '';
  
  return trimmed.length > 30 ? trimmed.slice(0, 30) : trimmed;
};

/**
 * Check if a nudge should be shown (delivered but not read)
 */
export const shouldShow = (nudge) => {
  return nudge.delivered_at !== null && nudge.read_at === null;
};

/**
 * Remove duplicate nudges by ID
 */
export const uniqueNudges = (nudges) => {
  const seen = new Set();
  return nudges.filter(nudge => {
    if (seen.has(nudge.id)) {
      return false;
    }
    seen.add(nudge.id);
    return true;
  });
};

/**
 * Sort nudges by creation date (oldest first for FIFO display)
 */
export const sortNudgesByDate = (nudges) => {
  return [...nudges].sort((a, b) => 
    new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
};

/**
 * Validate text for nudge creation
 */
export const validateNudgeText = (text) => {
  if (!text || !text.trim()) {
    return { isValid: false, error: 'Message cannot be empty' };
  }
  
  const trimmed = text.trim();
  if (trimmed.length > 30) {
    return { isValid: false, error: 'Message must be 30 characters or less' };
  }
  
  return { isValid: true };
};

/**
 * Format timestamp for display
 */
export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  
  return date.toLocaleDateString();
};
